import _regeneratorRuntime from "D:/fsm/acro-harvest/frontend/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/fsm/acro-harvest/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RecordRTC from "recordrtc";
export default {
  data: function data() {
    return {
      recorder: null,
      recordingStarted: false,
      recordingPaused: false,
      audioBlob: null
    };
  },
  model: {
    prop: "audioDataURL",
    event: "input"
  },
  props: {
    audioDataURL: {
      type: [String],
      default: null
    }
  },
  methods: {
    resetPlayer: function resetPlayer() {
      var player = document.getElementById("audio-player");
      player.currentTime = 0;
      player.pause();
      player.src = null;
    },
    startRecording: function startRecording() {
      var _this = this;

      _this.audioBlob = null;

      _this.resetPlayer();

      _this.$emit("input", null);

      _this.$emit("start-recording", true);

      _this.$emit("stop-recording", false);

      navigator.mediaDevices.getUserMedia({
        audio: true
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(stream) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.recorder = RecordRTC(stream, {
                    type: "audio",
                    mimeType: "audio/wav",
                    disableLogs: true
                  });

                  _this.recorder.startRecording();

                  _this.recordingStarted = true;

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    stopRecording: function stopRecording() {
      var _this = this;

      _this.recorder.stopRecording(function () {
        _this.recordingStarted = false;
        _this.audioBlob = _this.recorder.toURL();

        _this.recorder.getDataURL(function (dataURL) {
          _this.$emit("input", dataURL);

          _this.$emit("stop-recording", true);
        });
      });
    },
    pauseRecording: function pauseRecording() {
      var _this = this;

      _this.recorder.pauseRecording();

      _this.recordingPaused = true;
    },
    resumeRecording: function resumeRecording() {
      var _this = this;

      _this.recorder.resumeRecording();

      _this.recordingPaused = false;
    },
    resetRecording: function resetRecording() {
      var _this = this;

      _this.recorder.reset();

      _this.recorder = null;
      _this.recordingStarted = false;
      _this.recordingPaused = false;
      _this.audioBlob = null;

      _this.resetPlayer();

      _this.$emit("input", null);

      _this.$emit("stop-recording", true);
    }
  }
};